import BlankContainer from '@components/blank/BlankContainer';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function BlankItem() {
    const { t } = useTranslation('items');
    return (
        <BlankContainer warmIcon={warmIcon()}
            coolIcon={coolIcon()} >
            {t('blank.noItems')}
        </BlankContainer>
    );
}

const warmIcon = () => (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="120" height="120" rx="14" fill="#F3F0ED"/>
        <rect x="16.875" y="90.625" width="84.375" height="10" fill="#D1CDC9"/>
        <path d="M93.0465 47.8984H64.7008V93.0957H93.0465V47.8984Z" fill="#E4E1DE"/>
        <path d="M64.6989 47.8984H25.779V93.0977H64.6989V47.8984Z" fill="#F3F0ED"/>
        <Path d="M64.6989 47.8984V57.6797L60.4138 63.9258H25.779V57.6797H56.8864L64.6989 47.8984Z"
            fill="#E4E1DE"/>
        <Path d="M64.699 58.4141V47.8984L72.5115 57.6797H93.0466V63.9258H69.1248L64.699 58.4141Z"
            fill="#E4E1DE"/>
        <path
            d="M93.6324 93.6816H64.1149V47.3047H93.6324V93.6816ZM65.2867 92.5098H92.4606V48.4766H65.2867V92.5098Z"
            fill="#AFA8A5"/>
        <path
            d="M65.2849 93.6836H25.1931V47.3047H65.2849V93.6836ZM26.3649 92.5117H64.113V48.4766H26.3649V92.5117Z"
            fill="#AFA8A5"/>
        <path d="M79.7362 83.209H69.453V88.5195H79.7362V83.209Z" fill="#AFA8A5"/>
        <path d="M56.8866 57.6797H17.0311L24.8436 47.8984H64.6991L56.8866 57.6797Z" fill="#FCFAF8"/>
        <path d="M72.5115 57.6797H101.375L93.5603 47.8984H64.699L72.5115 57.6797Z" fill="#FCFAF8"/>
        <path
            d="M57.1678 58.2656H15.8124L24.5624 47.3047H65.9178L57.1678 58.2656ZM18.2499 57.0937H56.6034L63.4823 48.4766H25.1268L18.2499 57.0937Z"
            fill="#AFA8A5"/>
        <path
            d="M102.592 58.2656H72.2303L63.4822 47.3047H93.8436L102.592 58.2656ZM72.7947 57.0937H100.156L93.2791 48.4766H65.9178L72.7947 57.0937Z"
            fill="#AFA8A5"/>
        <circle cx="61" cy="29" r="16.4" fill="#FCFAF8" stroke="#AFA8A5" strokeWidth="1.2"/>
        <path
            d="M58 19.0108V26.7455L58.9368 31.5729H60.9961V31.5765L63.0555 31.5729L63.9923 26.7383L64 19L58 19.0108Z"
            fill="#6E6864"/>
        <path d="M63.1247 35.0698H58.839V39H63.1247V35.0698Z" fill="#6E6864"/>
    </svg>
);

const coolIcon = () => (
    <svg width="120" height="120" viewBox="0 0 120 120" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <rect width="120" height="120" rx="14" fill="#EDF1F3"/>
        <rect x="16.875" y="90.625" width="84.375" height="10" fill="#C9CDD1"/>
        <path d="M93.0465 47.8984H64.7008V93.0957H93.0465V47.8984Z" fill="#DEE1E4"/>
        <path d="M64.6989 47.8984H25.779V93.0977H64.6989V47.8984Z" fill="#EDF1F3"/>
        <Path d="M64.6989 47.8984V57.6797L60.4138 63.9258H25.779V57.6797H56.8864L64.6989 47.8984Z"
            fill="#DEE1E4"/>
        <Path d="M64.699 58.4141V47.8984L72.5115 57.6797H93.0466V63.9258H69.1248L64.699 58.4141Z"
            fill="#DEE1E4"/>
        <path
            d="M93.6324 93.6816H64.1149V47.3047H93.6324V93.6816ZM65.2867 92.5098H92.4606V48.4766H65.2867V92.5098Z"
            fill="#A5AAAF"/>
        <path
            d="M65.2849 93.6836H25.1931V47.3047H65.2849V93.6836ZM26.3649 92.5117H64.113V48.4766H26.3649V92.5117Z"
            fill="#A5AAAF"/>
        <path d="M79.7362 83.209H69.453V88.5195H79.7362V83.209Z" fill="#A5AAAF"/>
        <path d="M56.8866 57.6797H17.0311L24.8436 47.8984H64.6991L56.8866 57.6797Z" fill="#F8FAFC"/>
        <path d="M72.5115 57.6797H101.375L93.5603 47.8984H64.699L72.5115 57.6797Z" fill="#F8FAFC"/>
        <path
            d="M57.1678 58.2656H15.8124L24.5624 47.3047H65.9178L57.1678 58.2656ZM18.2499 57.0937H56.6034L63.4823 48.4766H25.1268L18.2499 57.0937Z"
            fill="#A5AAAF"/>
        <path
            d="M102.592 58.2656H72.2303L63.4822 47.3047H93.8436L102.592 58.2656ZM72.7947 57.0937H100.156L93.2791 48.4766H65.9178L72.7947 57.0937Z"
            fill="#A5AAAF"/>
        <circle cx="61" cy="29" r="16.4" fill="#F8FAFC" stroke="#A5AAAF" strokeWidth="1.2"/>
        <path
            d="M58 19.0108V26.7455L58.9368 31.5729H60.9961V31.5765L63.0555 31.5729L63.9923 26.7383L64 19L58 19.0108Z"
            fill="#64696E"/>
        <path d="M63.1247 35.0698H58.839V39H63.1247V35.0698Z" fill="#64696E"/>
    </svg>
);

const Path = styled.path`
    mix-blend-mode: multiply;
`;

export default BlankItem;
